import { SignUpProductEnum } from "components/Signup/flow/SignupFlow/types";
import {
  ProductEnum,
  SpeciesEnum,
} from "../../../../../../__generated__/globalTypes";

export function getResparkProductNameFromSignupProduct({
  product,
  species,
}: {
  product: SignUpProductEnum | null;
  species: SpeciesEnum | null;
}): ProductEnum {
  const isLiability = product === SignUpProductEnum.liability;

  return isLiability
    ? ProductEnum.liability
    : (species as unknown as ProductEnum);
}
